function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h20l10 9.75V40H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#343333",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 13C9.476 13 5 17.59 5 23.254c0 4.53 2.865 8.372 6.84 9.728.5.094.682-.222.682-.494 0-.243-.009-.888-.014-1.744-2.782.62-3.369-1.374-3.369-1.374-.454-1.184-1.11-1.5-1.11-1.5-.908-.636.07-.623.07-.623 1.002.072 1.53 1.057 1.53 1.057.893 1.566 2.341 1.114 2.911.851.09-.662.35-1.114.635-1.37-2.22-.26-4.555-1.139-4.555-5.067 0-1.12.39-2.035 1.03-2.752-.104-.26-.447-1.302.097-2.713 0 0 .84-.276 2.75 1.05A9.381 9.381 0 0115 17.959c.849.005 1.705.118 2.503.346 1.91-1.327 2.747-1.051 2.747-1.051.546 1.411.203 2.454.1 2.713.64.717 1.028 1.632 1.028 2.752 0 3.938-2.338 4.805-4.566 5.059.359.316.679.942.679 1.899 0 1.37-.013 2.476-.013 2.812 0 .275.18.594.688.493 3.97-1.359 6.833-5.2 6.833-9.727C25 17.59 20.523 13 15 13",
  fill: "#FFF",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  fillRule: "nonzero",
  mask: "url(#b)",
  d: "M20 0h10v10H20z"
}));

var SvgGithub = function SvgGithub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGithub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/github.370923e3.svg";
export { ForwardRef as ReactComponent };